export default {
    common: {
        title: 'Muokkaa kuvaa',
        cancel: 'Peruuttaa',
        save: 'Tallenna',
        crop: 'Sato',
        adjustments: 'Säädökset',
        filters: 'Suodattimet',
        frames: 'Kehykset',
        overlays: 'Kerroksia',
        text: 'Teksti',
        stickers: 'Tarroja',
        brush: 'Harja',
        ai: 'Luo kuva käyttäen tekoälyä',
        reset: 'Nollaa',
        comingSoon: 'Tulossa pian...',
        apply: 'Hae',
        undo: 'Kumoa',
        redo: 'tehdä uudelleen',
        flipHorizontal: 'Käännä vaaka',
        flipVertical: 'Käännä vertikaalisesti',
        rotateClockwise: 'Kiertäminen myötäpäivään',
        rotateAntiClockwise: 'Kierrä vastapäivään',
        warning: 'Varoitus',
        discard: 'Hylätä',
        continue: 'Jatka muokkaamista',
        discardHeading: 'Hylkää muutoksesi?',
        discardSubHeading: 'Jos suljet kuvankäsittelyn, muutoksesi eivät tallennu',
        subtitle: 'Tuetut kuvamuodot ovat PNG ja JPEG',
        clone: 'Kloonata',
        delete: 'Poista',
    },
};
